import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle, XCircle, FolderX } from 'lucide-react';
export function HookAndProblem() {
  return <section className="bg-cream py-20 px-6 text-charcoal" data-id="element-74">
      <div className="max-w-4xl mx-auto space-y-20" data-id="element-75">
        {/* Opening Hook */}
        <FadeIn data-id="element-76">
          <div className="text-center space-y-6" data-id="element-77">
            <h3 className="text-3xl md:text-4xl font-bold text-navy" data-id="element-78">
              ¿Sabías que la mayoría de las familias pierden acceso a sus fotos
              más preciadas y documentos bancarios importantes?
            </h3>
            <p className="text-xl md:text-2xl leading-relaxed" data-id="element-79">
              Esto sucede simplemente porque nadie conoce las contraseñas o no
              encuentran los archivos en un momento de emergencia.
            </p>
            <div className="bg-white p-8 rounded-2xl shadow-lg border-l-8 border-gold mt-8" data-id="element-80">
              <p className="text-2xl font-bold text-navy italic" data-id="element-81">
                "No dejes que el esfuerzo de toda tu vida se convierta en un
                'caos invisible' que tus seres queridos no puedan resolver."
              </p>
            </div>
          </div>
        </FadeIn>

        {/* The Problem */}
        <FadeIn data-id="element-82">
          <div className="space-y-8" data-id="element-83">
            <h3 className="text-3xl font-bold text-center text-navy mb-10" data-id="element-84">
              La Ansiedad Silenciosa del Desorden Digital
            </h3>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-85">
              <div className="bg-white p-8 rounded-xl shadow-md flex gap-4" data-id="element-86">
                <FolderX className="w-10 h-10 text-red-500 flex-shrink-0" data-id="element-87" />
                <p className="text-lg" data-id="element-88">
                  Has acumulado miles de fotos en WhatsApp, correos electrónicos
                  con facturas importantes y contraseñas anotadas en papeles que
                  se pierden.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-md flex gap-4" data-id="element-89">
                <AlertTriangle className="w-10 h-10 text-red-500 flex-shrink-0" data-id="element-90" />
                <p className="text-lg" data-id="element-91">
                  El desorden digital genera miedo a que, si algo te sucede
                  mañana, tu familia se quede bloqueada fuera de tu vida.
                </p>
              </div>
            </div>
            <p className="text-xl text-center mt-8 bg-navy text-white p-6 rounded-xl" data-id="element-92">
              Las aplicaciones modernas están hechas para jóvenes expertos,
              dejándote con la frustración de no saber cómo organizar tus
              propios recuerdos y documentos en este nuevo mundo digital.
            </p>
          </div>
        </FadeIn>

        {/* Why what you tried didn't work */}
        <FadeIn data-id="element-93">
          <div className="bg-white rounded-2xl p-10 shadow-xl border border-gray-100" data-id="element-94">
            <h3 className="text-3xl font-bold text-navy mb-8 text-center" data-id="element-95">
              Por qué lo que has intentado no funciona:
            </h3>
            <ul className="space-y-6" data-id="element-96">
              <li className="flex items-start gap-4" data-id="element-97">
                <XCircle className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-98" />
                <p className="text-xl" data-id="element-99">
                  <strong data-id="element-100">La Nube es Confusa:</strong> Aplicaciones como iCloud
                  o Google Drive cambian constantemente sus menús y son
                  difíciles de entender.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-101">
                <XCircle className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-102" />
                <p className="text-xl" data-id="element-103">
                  <strong data-id="element-104">Pedir Ayuda Frustra:</strong> Pedirle ayuda a tus
                  familiares suele terminar mal porque ellos lo hacen rápido y
                  no te explican el proceso.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-105">
                <XCircle className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-106" />
                <p className="text-xl" data-id="element-107">
                  <strong data-id="element-108">Las USB son Riesgosas:</strong> Guardar todo en
                  memorias USB es peligroso porque se dañan, se pierden o se
                  vuelven obsoletas con el tiempo.
                </p>
              </li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn data-id="element-109">
          <div className="text-center pt-4" data-id="element-110">
            <a href="https://dancodigital.com/cart/44413385211987:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-yellow-600 text-white font-bold py-4 px-10 rounded-xl shadow-xl transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl text-xl w-full md:w-auto text-center" data-id="element-111">
              ¡Quiero Proteger Mi Legado Ahora!
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}